  const lowSeverity = "#2cbafc";
  const mediumSeverity = "#fd9e29";
  const highSeverity = "#d419a8";
  const noSeverity = "#a1a1a1";
  const logSource = "#9941fc";
  
  export const resourceHealth = {
            labels: ["High severity", "Medium severity", "Low severity"],
            datasets: [
                {
                    backgroundColor: [
                        highSeverity,
                        mediumSeverity,
                        lowSeverity
                    ],
                    data: [5,10,15]
                }
            ]
        };

export const securityAlertsLastMonth = {
    lowSeverities: 278,
	mediumSeverities: 344,
	highSeverities: 289
};

 export const securityAlerts = {
            labels: [
                '22/5',
                '23/5',
                '24/5',
                '25/5',
                '26/5',
                '27/5',
                '28/5'
            ],  
            datasets: [{
                type: 'bar',
                label:'high',
                data: [300, 300, 300, 0,200,150,222],
                backgroundColor: highSeverity

            },{
                type: 'bar',
                label:'medium',
                data: [300, 300, 300, 0,200,150,222],
                backgroundColor: mediumSeverity
                

            },{
                type: 'bar',
                label:'low',
                data: [300, 300, 300, 0,200,150,222],
                backgroundColor: lowSeverity                
            }]
        };

export const securityAlertsLastWeek = {
    firstDay: { timeStamp: new Date(), lowSeverityCount: 5, mediumSeverityCount: 40, highSeverityCount: 10 },
    secondDay: { timeStamp: new Date(), lowSeverityCount: 6, mediumSeverityCount: 10, highSeverityCount: 2 },
    thirdDay: { timeStamp: new Date(), lowSeverityCount: 7, mediumSeverityCount: 2, highSeverityCount: 5 },
    fourthDay: { timeStamp: new Date(), lowSeverityCount: 8, mediumSeverityCount: 0, highSeverityCount: 9 },
    fifthDay: { timeStamp: new Date(), lowSeverityCount: 9, mediumSeverityCount: 25, highSeverityCount: 8 },
    sixthDay: { timeStamp: new Date(), lowSeverityCount: 20, mediumSeverityCount: 33, highSeverityCount: 4 },
    seventhDay: { timeStamp: new Date(), lowSeverityCount: 40, mediumSeverityCount: 65, highSeverityCount: 5 }
};

export const logsPerDay = {
    logSizeDay: [
        { timestamp: "2017-01-02", size: 10000 },
        { timestamp: "2017-02-02", size: 200000 },
        { timestamp: "2017-03-02", size: 15000 },
        { timestamp: "2017-04-02", size: 12000 },
        { timestamp: "2017-05-02", size: 23000 },
        { timestamp: "2017-06-02", size: 12000 },
        { timestamp: "2017-07-02", size: 9000 }
]};

export const logsSources = [
    { type: "Firewall", numberOnline: 6, numberAvailable: 6 },
    { type: "Router", numberOnline: 4, numberAvailable: 7 },
    { type: "Linux", numberOnline: 2, numberAvailable: 3 },
    { type: "Windows", numberOnline: 10, numberAvailable: 10 }
];

export const deviceGroups = [
    { groupName: "linux", isAllOnline: true, numberOfDevices: 2, numberOfDevicesOnline: 2 },
    { groupName: "ad", isAllOnline: false, numberOfDevices: 3, numberOfDevicesOnline: 2 },
    { groupName: "firewall", isAllOnline: false, numberOfDevices: 2, numberOfDevicesOnline: 1 }
];


// WEBPACK FOOTER //
// ./src/dashboard/mockData.js